interface ProgressPageProps {
    title: string;
    spinner?: boolean;
}

const ProgressPage = ({ title, spinner = true }: ProgressPageProps) => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-surface" role="status">
            <div className="text-2xl font-bold mb-4 text-foreground">{title}</div>
            {spinner && (
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" aria-hidden="true"></div>
            )}
        </div>
    );
};

export default ProgressPage;
